// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
export let DirectAssetMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_ASSET_TYPE_MESSAGE)
    this.Id = 0
    this.Type = 0
    this.Name = null
    this.Description = null
    this.MinChange = 0
    this.RouteId = null
    this.InstrumentId = null
    this.CreditForSell = null
    this.LiquidityRate = null
    this.InstrumentTradableID = -1;
}

DirectAssetMessage.prototype = Object.create(DirectMessageBase.prototype)